import { render, staticRenderFns } from "./InsiderVersion2.vue?vue&type=template&id=22efcdac&scoped=true&"
import script from "./InsiderVersion2.vue?vue&type=script&lang=js&"
export * from "./InsiderVersion2.vue?vue&type=script&lang=js&"
import style0 from "./InsiderVersion2.vue?vue&type=style&index=0&id=22efcdac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22efcdac",
  null
  
)

export default component.exports